import React from 'react';

export const EXPERIENCE_LENGTH = 183;

export function Experience() {
    return <>
        <>- 10+ years working in software engineering</><br/>
        <>- 4+ years AWS experience (CDK, Lambda, SQS, EventBridge, etc.)</><br/>
        <>- 6+ years Java & Spring experience</><br/>
        <>- 5+ years Typescript experience</><br/>
    </>;
}
